module.exports = __webpack_public_path__ + "img/14.bd6526bf.jpg";